/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Form,
  Modal,
  Header,
  Button,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import { TRANSLATION_FILES } from '../../constants/translation';
import InputBirthdate from '../../components/InputBirthdate';
import ModalConfirm from '../modals/ModalConfirm';
import { DEVELOPER_CANCELLED, LAWYER_LA_STATUSES, LAWYER_SPA_STATUSES, SPA_SIGNED, TYPE_CASE_LA, TYPE_CASE_SPA } from '../../constants/lawyerCaseStatuses';
import { getConstantsLabel } from '../../utils/translation';

class CaseAssignmentModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    loading: PropTypes.bool,
    isProjectHimsEnabled: PropTypes.bool,
    onClose: PropTypes.func,
    onUpdate: PropTypes.func,
    open: PropTypes.bool,
    selectedStatus: PropTypes.string,
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      caseStatuses: [],
      currentCase: null,
      currentStatus: null,
      spaDate: null,
      spaSolicitorRefNo: '',
      spaStampedDate: null,
    };
  }
  componentDidMount() {
    if (this.props.data) {
      this.setCaseDetails(this.props.data);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setCaseDetails(nextProps.data);
    }
  }

  setCaseDetails = (data) => {
    let newCaseStatuses = [...this.state.caseStatuses];
    const newCurrentCase = { ...data };
    let status = null;
    if (data) {
      if (data.type === TYPE_CASE_SPA) newCaseStatuses = LAWYER_SPA_STATUSES;
      if (data.type === TYPE_CASE_LA) newCaseStatuses = LAWYER_LA_STATUSES;
      status = newCaseStatuses.find(s => s.value === data.status);
    }
    // store previous spa_date for comparison in API
    if (newCurrentCase && newCurrentCase.extra_data) {
      newCurrentCase.extra_data.previous_spa_date = newCurrentCase.extra_data.spa_date;
    }
    this.setState({
      caseStatuses: newCaseStatuses,
      currentStatus: status,
      currentCase: newCurrentCase,
    });
  }

  handleOnDateChange = (day, name) => {
    const newCurrentCase = { ...this.state.currentCase };
    if (newCurrentCase && newCurrentCase.extra_data) {
      newCurrentCase.extra_data[name] = day;
    } else {
      newCurrentCase.extra_data = { [name]: day };
    }
    this.setState({ currentCase: newCurrentCase });
  }

  handleOnInputChange = (e, { name, value }) => {
    const newCurrentCase = { ...this.state.currentCase };
    if (newCurrentCase && newCurrentCase.extra_data) {
      newCurrentCase.extra_data[name] = value;
    } else {
      newCurrentCase.extra_data = { [name]: value };
    }

    this.setState({ currentCase: newCurrentCase });
  }

  renderSpaSignedContent = () => {
    const { selectedStatus, t, loading, isProjectHimsEnabled } = this.props;
    const { caseStatuses, currentCase } = this.state;
    const now = moment().toDate();
    const toMonth = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
    const fromMonth = new Date(2015, 0, 1);
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>Are you sure you want to change the status to {selectedStatus ? getConstantsLabel(t, caseStatuses, selectedStatus) : ''}?</Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>Please fill in the details</Grid.Column>
        </Grid.Row>
        <Grid.Row className="lawyer-title-pb-row">
          <Grid.Column>SPA Date{isProjectHimsEnabled ? '*' : ''}</Grid.Column>
        </Grid.Row>
        <Grid.Row className="lawyer-input-pt-row">
          <Grid.Column>
            <InputBirthdate
              date={currentCase && currentCase.extra_data && currentCase.extra_data.spa_date ? moment(currentCase.extra_data.spa_date).format('YYYY-MM-DD') : ''}
              disabled={loading}
              disabledDays={{ before: fromMonth, after: toMonth }}
              format={null}
              fromMonth={fromMonth}
              monthLogic={null}
              onSelectDay={d => this.handleOnDateChange(d, 'spa_date')}
              showMonth={currentCase && currentCase.extra_data && currentCase.extra_data.spa_date ? null : now}
              toMonth={toMonth}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="lawyer-title-pt-row lawyer-title-pb-row">
          <Grid.Column>SPA Stamped Date</Grid.Column>
        </Grid.Row>
        <Grid.Row className="lawyer-input-pt-row">
          <Grid.Column>
            <InputBirthdate
              date={currentCase && currentCase.extra_data && currentCase.extra_data.spa_stamped_date ? moment(currentCase.extra_data.spa_stamped_date).format('YYYY-MM-DD') : ''}
              disabled={loading}
              disabledDays={{ before: fromMonth, after: toMonth }}
              format={null}
              fromMonth={fromMonth}
              monthLogic={null}
              onSelectDay={d => this.handleOnDateChange(d, 'spa_stamped_date')}
              showMonth={currentCase && currentCase.extra_data && currentCase.extra_data.spa_stamped_date ? null : now}
              toMonth={toMonth}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="lawyer-title-pt-row">
          <Grid.Column>
            <Form className="lawyer-confirmation-form-input">
              <Form.Input
                fluid
                name="spa_solicitor_ref_no"
                label="SPA Solicitor Reference No"
                value={currentCase && currentCase.extra_data ? currentCase.extra_data.spa_solicitor_ref_no : ''}
                onChange={this.handleOnInputChange}
              />
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  render() {
    const { open, onClose, onUpdate, selectedStatus, t } = this.props;
    const { currentCase, currentStatus, caseStatuses } = this.state;

    return (
      <div>
        <ModalConfirm
          open={open && selectedStatus !== SPA_SIGNED}
          onClose={onClose}
          onConfirm={e => onUpdate(e, currentStatus ? currentStatus.value : null, currentCase)}
          headerNode={(<span>{t(`Confirm ${selectedStatus === DEVELOPER_CANCELLED ? 'cancel' : 'update'}`)}?</span>)}
          content={
            <Trans ns={TRANSLATION_FILES.screens}>
              {
                selectedStatus === DEVELOPER_CANCELLED && (
                  <p>Are you sure you want to cancel the assignment of <strong>{{ lawyerName: currentCase.lawyer ? currentCase.lawyer.name : '' }}</strong> from this case?</p>
                )
              }
              {
                selectedStatus !== SPA_SIGNED && selectedStatus !== DEVELOPER_CANCELLED && (
                  <p>Are you sure you want to change the status from <strong>{{ currentStatus: currentStatus ? t(currentStatus.text, { ns: TRANSLATION_FILES.constants }) : '' }}</strong> to <strong>{{ newStatus: selectedStatus ? getConstantsLabel(t, caseStatuses, selectedStatus) : '' }}</strong>?</p>
                )
              }
            </Trans>
          }
        />
        <Modal
          open={open && selectedStatus === SPA_SIGNED}
          onClose={onClose}
          size="tiny"
        >
          <Header icon="file text outline" content={`Change status to ${selectedStatus ? getConstantsLabel(t, caseStatuses, selectedStatus) : ''}`} />
          <Modal.Content>
            <Modal.Description>{this.renderSpaSignedContent()}</Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <span>All fields marked with an * are required</span>
            <Button negative onClick={onClose} icon="cancel" content={t('No', { ns: TRANSLATION_FILES.translation })} />
            <Button
              positive
              onClick={e => onUpdate(e, currentStatus ? currentStatus.value : null, currentCase)}
              icon="checkmark"
              content={t('Yes', { ns: TRANSLATION_FILES.translation })}
              data-bot-target="confirm"
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(CaseAssignmentModal);



// WEBPACK FOOTER //
// ./src/containers/Lawyer/CaseAssignmentModal.jsx